import React, { useState } from 'react';
import { ChakraProvider, extendTheme, Box, Flex, Button, Heading, Text, CSSReset } from '@chakra-ui/react';
import { StarIcon, SearchIcon, WarningIcon } from '@chakra-ui/icons'; // Aggiunto per completezza

// Importa i componenti delle pagine
import CheckRisk from './components/CheckRisk';
import ReportForm from './components/ReportForm';
import Blacklist from './components/Blacklist'; // Importato il nuovo componente


// 1. Definisci il Tema (per sovrascrivere il default e personalizzare)
const theme = extendTheme({
  colors: {
    brand: {
      900: '#1a365d',
      800: '#153e75',
      700: '#2a69ac',
    },
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 'lg', 
      },
    },
    Input: {
      baseStyle: {
        borderRadius: 'lg',
      }
    }
  }
});

// Componente per la navigazione (simulazione di routing)
const Navigation = ({ activePage, navigate }) => (
  <Flex 
    as="nav" 
    bg="white" 
    p={4} 
    borderBottom="1px" 
    borderColor="gray.200"
    justifyContent="space-between"
    alignItems="center"
    boxShadow="sm"
  >
    <Heading size="md" color="teal.700">Anti-Truffa</Heading>
    <Flex>
      <Button 
        variant={activePage === 'check' ? 'solid' : 'ghost'} 
        colorScheme="teal"
        onClick={() => navigate('check')}
        mx={1}
        leftIcon={<SearchIcon />}
      >
        Verifica
      </Button>
      <Button 
        variant={activePage === 'report' ? 'solid' : 'ghost'} 
        colorScheme="red"
        onClick={() => navigate('report')}
        mx={1}
        leftIcon={<WarningIcon />}
      >
        Segnala
      </Button>
      <Button 
        variant={activePage === 'blacklist' ? 'solid' : 'ghost'} 
        colorScheme="purple"
        onClick={() => navigate('blacklist')}
        mx={1}
        leftIcon={<StarIcon />}
      >
        Blacklist
      </Button>
    </Flex>
  </Flex>
);

// Componente principale dell'applicazione
const App = () => {
  // Simula il routing (usando 'check', 'report' o 'blacklist')
  const [currentPage, setCurrentPage] = useState('check');

  const navigateTo = (page) => {
    setCurrentPage(page);
  };
  
  // Renderizza il componente corretto in base allo stato
  const renderPage = () => {
    switch (currentPage) {
      case 'check':
        return <CheckRisk navigate={navigateTo} />;
      case 'report':
        return <ReportForm navigate={navigateTo} />;
      case 'blacklist':
        return <Blacklist navigate={navigateTo} />;
      default:
        return <CheckRisk navigate={navigateTo} />;
    }
  };

  return (
    <ChakraProvider theme={theme}>
      <CSSReset /> 
      <Box minH="100vh">
        <Navigation activePage={currentPage} navigate={navigateTo} />
        <Box as="main" p={4}>
          {renderPage()}
        </Box>
        <Box as="footer" textAlign="center" p={4} mt={10} color="gray.500" fontSize="sm">
            <Text>
                Progetto Anti-Truffa | Backend API su localhost:3000
            </Text>
        </Box>
      </Box>
    </ChakraProvider>
  );
};

export default App;